import Param from '../../param';
import effectManager from '../effect';
import AnimationMnager from '../animation';

const param = new Param();
const effect = new effectManager();
const animation = new AnimationMnager();


export default class ModalSet{
    constructor($container,$bg){
        this.$container = $container;
        this.$bg = $bg;

        effect.splitText($container.find(".number,.title"),"set");
        effect.show($container.find(".modal-cnt .text,#p-column-modal-body-page,.p-column-illust >*,#p-column-modal-body-ctrl-next,#p-column-modal-body-ctrl-prev,#p-column-modal-close"),"set");

        TweenMax.set(this.$bg,{
            // scale : 0,
            opacity : 0
        });
        
    }
}
